/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Deck_Credit_EditInputs */



/**
* | output |
* | --- |
* | "Change" |
*
* @param {Deck_Credit_EditInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const deck_credit_edit = /** @type {((inputs?: Deck_Credit_EditInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Deck_Credit_EditInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Modifier")
	if (locale === "es") return /** @type {LocalizedString} */ ("Cambiar")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Alterar")
	if (locale === "it") return /** @type {LocalizedString} */ ("Modifica")
	return /** @type {LocalizedString} */ ("Change")
});